import { useMemo, useState } from 'react';
import { DisplaySwitch } from '@blockanalitica/ui';
import CapitalAtRiskGraph from './CapitalAtRiskGraph';
import CapitalAtRiskHistoricGraph from './CapitalAtRiskHistoricGraph';

export default function CollateralAtRiskTabs() {
  const [activeGraph, setActiveGraph] = useState('current');

  const displayOptions = useMemo(
    () => [
      { key: 'current', value: 'Collateral At Risk' },
      { key: 'historic', value: 'Collateral At Risk Historic' }
    ],
    []
  );

  return (
    <>
      <DisplaySwitch
        data={displayOptions}
        activeOption={activeGraph}
        onChange={setActiveGraph}
      />
      {activeGraph === 'current' ? (
        <CapitalAtRiskGraph />
      ) : (
        <CapitalAtRiskHistoricGraph />
      )}
    </>
  );
}
